/* @flow */
import { apiService } from 'services/ServiceRegistry';
import navigation from 'services/NavigationService';

import { activities } from 'components/Activity/ActivityData.js';
import { Roles } from 'permissions/defs';
import { customerUsers } from 'permissions/userTypes';

import Form from '../_.extend';

export const makeFields = (accountID: string, t: Function) => {
  return [
    {
      // USER EMAIL
      name: 'userEmail',
      label: t('general:users.labels.email'),
      fields: [
        {
          name: 'emailAddress',
          label: t('general:labels.email_address'),
          type: 'email',
          rules: 'required|validEmailDomain',
          value: '',
        },
      ],
    },
    {
      // CHOOSE ACCOUNT | Is disabled here but is used
      name: 'chooseAccount',
      label: t('general:trading_account'),
      fields: [
        {
          name: 'tradingAccount',
          label: t('general:trading_account'),
          rules: 'required|string',
          value: accountID,
          extra: {
            selectID: accountID,
          },
        },
      ],
    },
    {
      // USER DETAILS
      name: 'userDetails',
      label: t('general:users.labels.details'),
      fields: [
        {
          name: 'firstName',
          label: t('general:labels.first_name'),
          rules: 'required',
          value: '',
        },
        {
          name: 'lastName',
          label: t('general:labels.last_name'),
          rules: 'required',
          value: '',
        },
        {
          name: 'phoneNumber',
          label: t('general:labels.phone_number'),
          rules: 'required|telephone',
          value: '',
        },
        {
          name: 'country',
          label: t('general:country'),
          rules: 'required',
        },
        {
          name: 'county',
          label: t('general:county'),
          rules: 'string',
          value: '',
        },
        {
          name: 'city',
          label: t('general:city'),
          rules: 'required|string',
          value: '',
        },
        {
          name: 'postcode',
          label: t('general:postcode'),
          rules: 'required|string',
          value: '',
        },
        {
          name: 'state',
          label: t('general:state'),
        },
      ],
    },
    {
      // SELECT USER ROLE
      name: 'selectUserRole',
      label: t('general:actions.select_user_role'),
      fields: [
        {
          name: 'role',
          type: 'radio',
          // label: 'Select User Role',
          rules: 'numeric|required',
          value: '',
          options: customerUsers.map(role => ({
            id: role,
            label: t(`general:roles.${role}`),
            value: role,
            hint: t(`general:roles.descriptions.${role}`),
          })),
        },
      ],
    },
    {
      name: 'assignOtherAccounts',
      label: t('general:actions.assign_other_accounts'),
      fields: [
        {
          name: 'accounts',
          label: t('general:actions.choose_trading_accounts_assigned_to_you'),
          type: 'textfield',
          rules: 'string',
          value: '',
        },
      ],
    },
  ];
};

class AccountsInviteUserForm extends Form {}

const inviteUserForm = (fields: Array<*>, accountID: string, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { emailAddress } = form.values().userEmail;
      const {
        firstName,
        lastName,
        phoneNumber,
        country,
        state,
        county,
        city,
        postcode,
      } = form.values().userDetails;
      const stateCounty = country === 'US' ? state : county;
      const { role }: Object = form.values().selectUserRole;
      const { accounts }: Object = form.values().assignOtherAccounts;
      const accountIds = accounts.split(',');
      const jsonObj: Object = {
        activity_tag: activities.userInvited.tag,
        user_emails: emailAddress,
        first_name: firstName,
        last_name: lastName,
        tel: phoneNumber, // required
        country_id: country.id, // required
        state: stateCounty, // required
        city, // required
        postcode, // required
        user_role: role,
        account_ids: accounts === '' ? [] : accountIds,
      };

      apiService
        .createResource(`accounts/${accountID}/invite-users`, jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = err.message || t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;

          return err;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new AccountsInviteUserForm(
    { fields },
    { hooks, name: t('general:actions.invite_new_user') }
  );
};

export const getForm = (accountID: string, localState: Object, t: Function) => {
  const fields = makeFields(accountID, t);
  return inviteUserForm(fields, accountID, localState, t);
};
